<template>
    <v-col cols="12" class="DailCompany mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium">Perfil Empresa - <span class="blue--text">Nombre Empresa</span></h2>
                    <v-row>
                            <v-col cols="12" lg="6" >
                        <v-row>
                                <v-col cols="4">
                                    <v-card
                                            class="pa-4 ma-0 elevation-5"
                                            tile
                                            height="150px"
                                            width="150px"
                                    >
                                        <v-img src="@/assets/images/neocity-logo.png"
                                                height="130px"
                                                width="130px"
                                                aspect-ratio="2"
                                                contain>
                                        </v-img>
                                    </v-card>
                                </v-col>
                                <v-col cols="8">
                                    <v-row class="caption">
                                        <v-col cols="12">
                                            <b>NEOCITY ENERGÍA - 76.859.223-7</b>
                                        </v-col>
                                    </v-row>
                                    <v-row class="caption">
                                        <v-col class="py-0">Nombre de Fantasía</v-col>
                                        <v-col class="py-0">Nombre de la empresa S.A</v-col>
                                    </v-row>
                                    <v-row class="caption">
                                        <v-col class="py-0">Giro Comercial</v-col>
                                        <v-col class="py-0">Energía</v-col>
                                    </v-row>
                                    <v-row class="caption">
                                        <v-col class="py-0">Direccion Comercial</v-col>
                                        <v-col class="py-0">Los militares 8659</v-col>
                                    </v-row>
                                    <v-row class="caption">
                                        <v-col class="py-0">Representante Legal</v-col>
                                        <v-col class="py-0">Marcos Cisternas</v-col>
                                    </v-row>
                                    <v-row class="caption">
                                        <v-col class="py-0">Sitio Web</v-col>
                                        <v-col class="py-0">www.neocity.cl</v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12">
                                    <p class="caption">
                                        Descripción:
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque blandit accumsan libero, facilisis interdum turpis rutrum vitae.
                                        Duis sit amet libero vitae ligula placerat hendrerit at quis massa. Nam vulputate pretium odio mattis rutrum. n sit amet efficitur urna.
                                        Phasellus vitae tempor magna. Etiam id pharetra ipsum. Curabitur id efficitur erat. <a class="text-underline" href="#"> Ver texto completo [+]</a>
                                    </p>
                                    <v-btn color="primary"
                                            raised
                                            outlined
                                            class="px-6 mt-5">
                                        Editar Empresa</v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" lg="5" >
                            <h2 class="font-weight-medium">Tu empresa en números</h2>
                            <v-row>
                                 <v-col cols="12"  lg="6">
                                        <v-card height="100px"  dark color="#4190DD" class="card-numeros shadow-1 rounded-lg pa-3">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="12"  lg="6">
                                        <v-card height="100px"  dark color="#4190DD" class="card-numeros shadow-1 rounded-lg pa-3">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                            </v-row>
                             <v-row>
                                 <v-col cols="12" >
                                        <v-card height="100px"  dark color="#47B51E" class="card-numeros shadow-1 rounded-lg pa-3">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                   
                            </v-row>
                            <v-row>
                                 <v-col cols="12"  lg="6" >
                                        <v-card height="100px"  dark color="#47B51E" class="card-numeros shadow-1 rounded-lg pa-3 ">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                     <v-col cols="12"  lg="3" >
                                        <v-card height="100px"  dark color="#47B51E" class="card-numeros shadow-1 rounded-lg pa-3 ">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                                     <v-col cols="12"  lg="3" >
                                        <v-card height="100px"  dark color="#47B51E" class="card-numeros shadow-1 rounded-lg pa-3 ">
                                            <v-row>
                                                <v-col cols="10" class="mx-auto">
                                                    <h2>150  <span>KW-mes</span></h2>
                                                    <p>Potencia Máxima</p>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>
                            </v-row>
                             <v-row>
                                 <v-col cols="12"  lg="6" >
                                    <v-row>
                                        <v-col cols="12"  lg="6" >
                                            <v-card height="100px"  dark color="#FFB129" class="card-numeros shadow-1 rounded-lg pa-3">
                                                <v-row>
                                                    <v-col cols="10" class="mx-auto">
                                                        <h2>150  <span>KW-mes</span></h2>
                                                        <p>Potencia Máxima</p>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12"  lg="6" >
                                            <v-card height="100px"  dark color="#FFB129" class="card-numeros shadow-1 rounded-lg pa-3 ">
                                                <v-row>
                                                    <v-col cols="10" class="mx-auto">
                                                        <h2>150  <span>KW-mes</span></h2>
                                                        <p>Potencia Máxima</p>
                                                    </v-col>
                                                </v-row>
                                            </v-card>
                                        </v-col>
                                    </v-row>
                                 </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    
                </v-card>
            </v-col>
        </v-row>

        <v-dialog
            v-model="dialog.show"
            width="70%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Validar Representante Legal
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam fringilla lacus vel porta vestibulum. Pellentesque varius, arcu vitae ornare posuere, ligula nulla interdum dolor</p>
                        </v-col>
                        <v-col cols="12" class="text-center">
                            <v-file-input label="Seleccionar archivo PDF" outlined dense></v-file-input>
                            <p class="caption">El archivo no debe superar los 10mb</p>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            outlined
                            class="px-6"
                            @click="dialog.show = false"
                    >
                        Ver mas Tarde
                    </v-btn>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.show = false"
                    >
                        Cargar El Documento
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
                v-model="dialog.sendData.show"
                width="70%"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-center">
                    Tu información ha sido enviada
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="8" class="mx-auto text-center">
                            <p>Hemos enviado toda tu infomacion al equipo de validación. Revisaremos tu información esté correcta y te enviaremos el link para que puedas completar tu registro y comenzar a ofertar enería</p>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.sendData.show = false"
                    >
                        Volver al Inicio
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


    </v-col>

</template>
<script>
    export default {
        name: 'DailCompany',
        data() {
            return {
                dialog: {
                    show: false,
                    sendData:{ show:false }
                }

            }
        },
        created: function () {
            this.$emit('SetcolorMenu', 'primary');
        }
    }
</script>